<div>Do we have permission for 'ManageAccountNotifications': {{ hasPermission }}</div>
